import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class LocalStoreService {
	public backClicked: boolean = false;

	private token: string;

	constructor(
		private router: Router
	) { }

	getToken(): string {
		return this.token;
	}

	setDataOnLogin(data: string) {
		this.token = data;
	}

	reset() {
		this.token = '';
	}

	forceLogout() {
		this.reset();
		sessionStorage.setItem("forceLogout", "true");
		this.router.navigate(['/'], { replaceUrl: true });
	}
}
